import axios from 'axios';

const STATUS_REGISTER_SUCCESS = '1';
const STATUS_USER_ALREADY_EXISTS = '3';
const STATUS_LOGIN_SUCCESS = '4';
const STATUS_LOGIN_NO_USER = '5';

const login = (email, password, cb = () => {}) => {
  axios.post('/api/authentication', { email, password }).then(response => cb(response.data));
};

const register = (email, password, firstName, lastName, marketing, cb = () => {}) => {
  axios.post('/api/register', { email, password, firstName, lastName, marketing }).then(response => {
    const { data } = response;
    cb(data);
  });
};

const recoverPassword = (email, cb = () => {}) => {
  axios
    .post('/api/recover_password', { email })
    .then(_ => cb(true))
    .catch(_ => cb(false));
};

const resetPassword = (password, recoveryCode, cb = () => {}) => {
  axios
    .post('/api/reset_password', { password, recoveryCode })
    .then(response => cb(true))
    .catch(_ => cb(false));
};

const logout = (cb = () => {}) => {
  axios.delete('/api/authentication').then(() => cb());
};

export {
  login,
  logout,
  register,
  recoverPassword,
  resetPassword,
  STATUS_LOGIN_SUCCESS,
  STATUS_REGISTER_SUCCESS,
  STATUS_USER_ALREADY_EXISTS,
  STATUS_LOGIN_NO_USER,
};
